import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'

const convert = (result) => {
  const style = []
  Object.keys(result).forEach((item) => {
    style.push({ label: result[item], value: result[item] })
  })
  return style
}
export default (props) => {
  const { rootCategoryId, placeholder = '不限', ...otherProps } = props
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchUsers()
  }, [rootCategoryId])
  const fetchUsers = async () => {
    try {
      const res = await request.get('/shop/tag/shop-styles?', { params: { rootCategoryId } })
      setOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select placement="bottomRight" multi {...otherProps} data={options} placeholder={placeholder} hiddenSearch />
}
